export default {
  title: 'Remember me',
  form: {
    remember_me: {
      label: 'Save my information for a faster checkout',
    },
  },
};
